import { FormGroup, Label, Input } from "reactstrap";
import _ from "lodash";
import { api } from "../utils";
import { toast } from "react-toastify";

export default function NotificationSettings({ flags, setFlags, type, disabled }) {

  function handleFlagChange(flagName) {
    const flagsCopy = _.assign({}, flags);
    flagsCopy[flagName] = !flagsCopy[flagName];
    setFlags(flagsCopy);

    api
      .post(`Customer/SaveInvoiceOrderFlags`, flagsCopy)
      .then((response) => {
        if (response.data.success) {
          toast.success("Settings updated");
        } else {
          toast.error("Error saving Settings");
        }
      })
      .catch(api.catchHandler);
  }

  const isOrder = type === "Order";
  return (
    <>
      <FormGroup check inline>
        <Label check>
          <Input
            type="checkbox"
            name={`email${type}`}
            checked={(flags && flags[`email${type}`]) || false}
            onChange={(e) => handleFlagChange(e.target.name)}
            disabled={disabled}
          />
          Email
        </Label>
      </FormGroup>
      <FormGroup check inline>
        <Label check>
          <Input
            type="checkbox"
            name={`fax${type}`}
            checked={(flags && flags[`fax${type}`]) || false}
            onChange={(e) => handleFlagChange(e.target.name)}
            disabled={disabled}
          />
          Fax
        </Label>
      </FormGroup>
      {isOrder ? null : (
        <FormGroup check inline>
          <Label check>
            <Input
              type="checkbox"
              name={`post${type}`}
              checked={(flags && flags[`post${type}`]) || false}
              onChange={(e) => handleFlagChange(e.target.name)}
              disabled={disabled}
            />
            Postal Mail
          </Label>
        </FormGroup>
      )}
    </>
  );
}
